import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { prepareHeaders, getApiBaseUrl, getApiConfigKey } from 'utility/Api'
import { CostObjectOption } from 'types/CostObject'
import { components } from 'types/api'
import apiConfig from './api-config'

export type CostObject = components['schemas']['CostObject']

const baseUrl = getApiBaseUrl()
const configKey = getApiConfigKey()
const apiPath = apiConfig[configKey].paths.apiPathFinance ?? ''

// Define a service using a base URL and expected endpoints
export const FinanceApi = createApi({
  reducerPath: 'financeApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseUrl}/${apiPath}`,
    prepareHeaders: async headers => await prepareHeaders(headers)
  }),
  endpoints: builder => ({
    getCostObject: builder.query<CostObjectOption, string>({
      query: q => `cost-objects/${q}`,
      transformResponse: (response: CostObject) => {
        return { id: response.code, valid: response.valid }
      }
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetCostObjectQuery } = FinanceApi
